module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "学员定级",
      "width": "650"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "modalForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.formData.uid) + "  - " + _vm._s(_vm.formData.mobile) + " - " + _vm._s(_vm.formData.nickname))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Level",
      "prop": "levelId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.levelId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "levelId", _vm._n($$v))
      },
      expression: "formData.levelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "(版本" + _vm._s(item.materialVersion) + ")\n            ")])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingBind
    },
    on: {
      "click": _vm.updateLevel
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb83deb6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/modal/UpdateLevelModal.vue
// module id = 1958
// module chunks = 8